module.exports = __webpack_public_path__ + "static/media/illustration-estrutura.f7b70745.svg";